import React from 'react';
import PropTypes from 'prop-types';

class UndoButton extends React.PureComponent {

  constructor(props) {
    super(props);

    this.timeout = null;

    this.onTimeout = this.onTimeout.bind(this);
    this.onClickUndo = this.onClickUndo.bind(this);
  }

  componentDidMount() {
    this.timeout = setTimeout(this.onTimeout, this.props.waitMs);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  onTimeout() {
    this.props.onDo();
  }

  onClickUndo() {
    clearTimeout(this.timeout);
    this.props.onUndo();
  }

  render() {
    return (
      <button className={`undo-button ${this.props.className}`} onClick={this.onClickUndo}>
        <svg viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="11" style={{animationDuration: `${this.props.waitMs}ms`}} />
        </svg>
        Undo
      </button>
    );
  }

}

UndoButton.propTypes = {
  onDo: PropTypes.func.isRequired,
  onUndo: PropTypes.func.isRequired,
  waitMs: PropTypes.number,
  className: PropTypes.string,
};

UndoButton.defaultProps = {
  waitMs: 5000,
  className: '',
};

export default UndoButton;
